<template>
  <div v-if="propElements">
    <template v-for="(item, index) in propElements" :key="index">
      <teleport :to="item.id">
        <template v-if="typeof item === 'string'">
          <div v-html="item"/>
        </template>
        <h2 v-else-if="item.type === 'h'" class="pt-8">
          {{ item.text }}
          <c-pointer :name="item.text"/>
        </h2>
        <c-alert v-else-if="item.type === 'alert'" v-bind="item" class="mb-8"/>
        <c-blockquote v-else-if="item.type === 'blockquote'" v-bind="item" class="mb-8"/>
        <c-image v-else-if="item.type === 'img'" v-bind="item"/>
        <c-accordion v-else-if="item.type === 'faq'" v-bind="item"/>
        <c-table v-else-if="item.type === 'table'" v-bind="item"/>
        <c-youtube v-else-if="item.type === 'youtube'" v-bind="item"/>
        <component v-else :is="item.type">
          <div v-html="item.html"/>
        </component>
      </teleport>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'
import CPointer from '@/components/CPointer'
import CAlert from '@/components/CAlert'
import CBlockquote from '@/components/CBlockquote'
import CImage from '@/components/CImage'
import CAccordion from '@/components/CAccordion'
import CTable from '@/components/CTable'
import CYoutube from '@/components/CYoutube'

export default {
  name: 'CPostElements',
  components: {
    CYoutube,
    CTable,
    CAccordion,
    CImage,
    CBlockquote,
    CAlert,
    CPointer
  },
  props: {
    elements: undefined
  },
  setup (props) {
    const propElements = computed(() => {
      if (props.elements && props.elements.length > 0) {
        const data = []
        props.elements.forEach(item => {
          if (document.querySelector(item.id)) {
            data.push(item)
          }
        })

        return data
      } else {
        return []
      }
    })

    return {
      propElements
    }
  }
}
</script>

<style scoped>

</style>
